import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Grupos',
    path: '/warehouse/groups',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
